import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { initialize, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Avatar, FormSection, GrayButton, SecondaryButton, Spinner } from 'components';
import { LLTextField } from 'components/FormElements';
import Dropzone from 'react-dropzone';
import { uploadAvatar as upload } from 'redux/modules/userSettings';
import * as styles from './UserSettingsForm.scss';

function validate(values) {
  var errors = {};

  if (values.password && values.password.length < 6) {
    errors.password = 'Passwords must be a minimum of 6 characters';
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords do not match';
  }

  return errors;
}

var UserProfileForm = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    uploading: state.userSettings.uploadingAvatar,
    uploadedAvatar: state.userSettings.uploadedAvatar
  };
}, {
  upload: upload
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(UserProfileForm, _Component);

  var _super = _createSuper(UserProfileForm);

  function UserProfileForm() {
    var _this;

    _classCallCheck(this, UserProfileForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (input, files) {
      if (files && files.length === 1) {
        _this.props.upload(files).then(function () {
          input.onChange(_this.props.uploadedAvatar.fullyQualifiedUrl);
        })["catch"](function (err) {
          console.error(err);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          className = _ref.className,
          _ref$meta = _ref.meta,
          active = _ref$meta.active,
          touched = _ref$meta.touched,
          error = _ref$meta.error;

      switch (type) {
        case 'avatar':
          return /*#__PURE__*/React.createElement(Dropzone, _extends({}, input, {
            multiple: false,
            onDrop: function onDrop(files) {
              return _this.handleDrop(input, files);
            },
            accept: 'image/*',
            style: {
              width: 120,
              height: 120,
              borderColor: '#8b8b8b',
              borderRadius: 4,
              border: '1px dashed #8b8b8b'
            }
          }), /*#__PURE__*/React.createElement("div", {
            style: {
              textAlign: 'center',
              position: 'relative',
              top: '20%',
              color: '#8b8b8b',
              fontSize: 13,
              padding: 8
            }
          }, _this.props.uploading ? /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }) : /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: 13
            }
          }, "Drag and drop a new avatar image here or click to upload.")));

        default:
          return /*#__PURE__*/React.createElement(LLTextField, _extends({}, input, {
            placeholder: label,
            type: type,
            className: className,
            id: input.name,
            errorText: !active && touched && error && /*#__PURE__*/React.createElement("span", null, error),
            style: {
              width: '100%'
            }
          }));
      }
    });

    return _this;
  }

  _createClass(UserProfileForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          uploadedAvatar = _this$props.uploadedAvatar,
          user = _this$props.user;
      var avatarImage = null;

      if (uploadedAvatar) {
        avatarImage = uploadedAvatar.fullyQualifiedUrl;
      } else if (user.avatarUrl) {
        avatarImage = user.avatarUrl;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormSection, {
        title: "Name",
        titleStyle: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "firstName",
        component: this.renderInput,
        label: "First Name",
        placeholder: "First Name"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "lastName",
        component: this.renderInput,
        label: "Last Name",
        placeholder: "Last Name"
      }))), /*#__PURE__*/React.createElement(FormSection, {
        title: "Avatar"
      }, avatarImage && /*#__PURE__*/React.createElement("div", {
        className: styles.dropZoneImage,
        style: {
          backgroundImage: "url(".concat(avatarImage, ")")
        }
      }), /*#__PURE__*/React.createElement(Field, {
        name: "avatarUrl",
        type: "avatar",
        component: this.renderInput,
        label: "",
        styles: styles
      })));
    }
  }]);

  return UserProfileForm;
}(Component), _defineProperty(_class2, "propTypes", {
  upload: PropTypes.func.isRequired,
  uploading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  uploadedAvatar: PropTypes.object
}), _temp)) || _class);
export { UserProfileForm as default };